module.exports = __webpack_public_path__ + "images/ituneslogo.png?fe964";